import { citylineFactory  } from "../../../FleetTracker/Infrastructure/Cityline";

export class HistoryStore { 
    private static _instance = new HistoryStore();
    public static get instance() { return HistoryStore._instance }
    private constructor() { }
    private _history: { [key: string]: string };

    public async initial(): Promise<{ [key: string]: string }> { 
        
        if (!this._history)
            this._history = await citylineFactory.client.getFrame<any>("history") as { [key: string]: string };
        
        return this._history;
    }
}
